import type { HelpFile } from '../../types/help'
import { RestConfigCardTestIds } from '../../../testids/RestConfigCardTestIds'

export const restConfigCardHelp: HelpFile = {
  docPage: '/docs/systems/connectors',
  texts: {
    [RestConfigCardTestIds.restConfigCard]: 'REST-Konfiguration eines ausgehenden Konnektors — wie IAM das Zielsystem aufruft, um Zugriffe zu gewähren und zu entziehen.',
    [RestConfigCardTestIds.cardTitleRestConfig]: null,
    [RestConfigCardTestIds.btnCreateRestConfig]: 'REST-Konfiguration für diesen Konnektor anlegen.',
    [RestConfigCardTestIds.btnEditRestConfig]: null,
    [RestConfigCardTestIds.selectRestAuthType]: 'Authentifizierungsverfahren beim Aufruf des Zielsystems — Basic Auth, Bearer Token oder OAuth2.',
    [RestConfigCardTestIds.selectRestGrantMethod]: 'HTTP-Methode zum Gewähren von Zugriff — POST oder PUT.',
    [RestConfigCardTestIds.selectRestRevokeMethod]: 'HTTP-Methode zum Entziehen von Zugriff — DELETE oder PUT.',
    [RestConfigCardTestIds.restAuthSecretRef]:
      'Referenz auf das Secret zur Authentifizierung ausgehender REST-Aufrufe.',
    [RestConfigCardTestIds.restGrantHeadersDisplay]:
      'HTTP-Header, die bei jedem Grant-Aufruf an das Zielsystem gesendet werden.',
    [RestConfigCardTestIds.restRevokeHeadersDisplay]:
      'HTTP-Header, die bei jedem Revoke-Aufruf an das Zielsystem gesendet werden.',
  },
}
